var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { classNames, kendoThemeMaps } from '@progress/kendo-react-common';
import { FormContext } from './FormContext';
/**
 * Represents the KendoReact FormElement component.
 * It's small wrapper around HTML form element which automatically attach the
 * Form component's `onSubmit` render prop and Kendo CSS classes.
 * Other props are passed to the DOM node.
 */
export var FormElement = React.forwardRef(function (props, ref) {
    var _a;
    var combinedProps = __assign({ size: 'medium' }, props);
    var element = React.useRef(null);
    var target = React.useRef(null);
    React.useImperativeHandle(target, function () { return ({ element: element.current, props: combinedProps }); });
    React.useImperativeHandle(ref, function () { return target.current; });
    var form = React.useContext(FormContext);
    var className = combinedProps.className, style = combinedProps.style, horizontal = combinedProps.horizontal, size = combinedProps.size, others = __rest(combinedProps, ["className", "style", "horizontal", "size"]);
    var formClassName = classNames((_a = {
            'k-form': true
        },
        _a["k-form-".concat(kendoThemeMaps.sizeMap[size] || size)] = size,
        _a['k-form-horizontal'] = horizontal === true,
        _a), className);
    return (React.createElement("form", __assign({ ref: element }, others, { style: props.style, className: formClassName, onSubmit: form ? form.onSubmit : undefined }), props.children));
});
FormElement.displayName = 'KendoReactFormElement';
